import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { PropertyGroup } from '../../components';

import css from './ListingPage.module.css';
import { localizeFilters } from '../../util/filtersLocalizationHelpers';

const SectionFeaturesMaybe = props => {
  const { options, publicData, intl } = props;
  if (!publicData) {
    return null;
  }

  const selectedOptions = publicData && publicData.area_c ? publicData.area_c : [];

  return (
    <div className={css.sectionDescription}>
      <h2 className={css.descriptionTitle}>
        <FormattedMessage id="ListingPage.featuresTitle" />
      </h2>

      <PropertyGroup
        id="area_c"
        options={localizeFilters(options, intl)}
        selectedOptions={selectedOptions}
        twoColumns={true}
      />
    </div>
  );
};

export default SectionFeaturesMaybe;
